import api from "./api";

const idempotencyKey = () =>
  "acc-" + Date.now() + "-" + Math.random().toString(16).slice(2);

const withIdempotency = (headers = {}) => ({
  headers: {
    ...headers,
    "Idempotency-Key": idempotencyKey(),
  },
});

export const accountingService = {
  getTreasuryPostingMap() {
    return api.get("/accounting/treasury-posting-map");
  },
  saveTreasuryPostingMap(id, accountingAccountId) {
    return api.put(`/accounting/treasury-posting-map/${id}`, { accountingAccountId }, withIdempotency());
  },
  createTreasuryPostingAccount(payload) {
    return api.post("/accounting/treasury-posting-accounts", payload, withIdempotency());
  },
  listPeriods() {
    return api.get("/accounting/periods");
  },
  createPeriod(payload) {
    return api.post("/accounting/periods", payload, withIdempotency());
  },
  closePeriod(id) {
    return api.post(`/accounting/periods/${id}/close`, {}, withIdempotency());
  },
  reopenPeriod(id) {
    return api.post(`/accounting/periods/${id}/reopen`, {}, withIdempotency());
  },

  listUnreconciledReceivables(params) {
    return api.get("/accounting/reconciliations/unreconciled-receivables", { params });
  },
  reconcileReceivables(payload) {
    return api.post("/accounting/reconciliations/reconcile-receivables", payload, withIdempotency());
  },
  unreconcileReceivables(payload) {
    return api.post("/accounting/reconciliations/unreconcile-receivables", payload, withIdempotency());
  },

  getTrialBalance(params) {
    return api.get("/accounting/reports/trial-balance", { params });
  },
  getAccountLedger(params) {
    return api.get("/accounting/reports/account-ledger", { params });
  },
  getCurrentAccountLedger(params) {
    return api.get("/accounting/reports/current-account-ledger", { params });
  },
  getVatSales(params) {
    return api.get("/accounting/reports/vat-sales", { params });
  },
  getVatPurchases(params) {
    return api.get("/accounting/reports/vat-purchases", { params });
  },
  getVatSettlement(params) {
    return api.get("/accounting/reports/vat-settlement", { params });
  },
  getBalanceSheet(params) {
    return api.get("/accounting/reports/balance-sheet", { params });
  },
  getIncomeStatement(params) {
    return api.get("/accounting/reports/income-statement", { params });
  },
  getIibbPerceptions(params) {
    return api.get("/accounting/reports/iibb-perceptions", { params });
  },
  getTaxWithholdings(params) {
    return api.get("/accounting/reports/tax-withholdings", { params });
  },
  getFiscalDashboard() {
    return api.get("/fiscal/dashboard");
  },
  getFiscalAlerts() {
    return api.get("/fiscal/alerts");
  },
  getStockValuation() {
    return api.get("/inventory/reports/stock-valuation");
  },
  getKardex(params) {
    return api.get("/inventory/reports/kardex", { params });
  },

  getOpsHealth() {
    return api.get("/ops/health");
  },
  getOpsMetrics() {
    return api.get("/ops/metrics");
  },
};
